var exports = {
  "w": "x31de4314--68cdc0--pessimization",
  "k": "x31de4314--68cdc0--strong",
};

module.exports = exports;
